import { useQuery } from "@tanstack/react-query";
import { listHostInstitutions } from "@/api/event-about";

/**
 * The host picker's counts: for each institution the caller runs, how many
 * follow it and how many publishing an event would tell. A business hosts
 * with no count, by design.
 */
export function HostAudiencePanel() {
  const { data } = useQuery({ queryKey: ["host-institutions"], queryFn: listHostInstitutions });
  const hosts = data?.data ?? [];
  if (hosts.length === 0) return null;
  return (
    <div className="card p-5">
      <h2 className="font-semibold mb-2">Hosting as an institution</h2>
      <ul className="text-sm text-gray-700 space-y-1">
        {hosts.map((h) => (
          <li key={h.id}>
            {h.name} · {h.followerCount} follow · publishing tells {h.eventFollowerCount}
            {h.can.createEvents ? "" : " · you may not create events here"}
          </li>
        ))}
      </ul>
    </div>
  );
}
